import React, { useLayoutEffect } from 'react';
import { useEffect, useState, useCallback } from 'react';
import { Calendar, momentLocalizer } from "react-big-calendar";
import { Table, Modal } from 'react-bootstrap';
import { db } from "../../utils/firebase";
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
} from "firebase/firestore";
import { useAuth } from "../../contexts/AuthContext";
import moment from "moment";

import "react-big-calendar/lib/css/react-big-calendar.css";

const localizer = momentLocalizer(moment);


const CalendarPageContent = () => {
  const [events, setEvents] = useState([]);
  const [modalInfo, setModalInfo] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { currentUser } = useAuth();
  const transactionsCollectionRef = query(
    collection(db, "transactions"),
    where("uId", "==", currentUser.auth.currentUser.uid),
    orderBy("date", "desc")
  );

  const getTransactions = async () => {
    const data = await getDocs(transactionsCollectionRef);

    // Set events for Calendar use
    setEvents(() => {
      // Get transactions from database
      let transactionArray = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      let category;
      let categories = [];
      let events = [];

      // Separate transactions by date and category
      for (const transaction of transactionArray) {
        if (categories.find(c => c.date === transaction.date && c.category === transaction.category)) {
          category = categories.find(c => c.date === transaction.date && c.category === transaction.category);
          category.amount += Number(transaction.amount);
          category.transactions.push(transaction);
        } else {
          category = {
            category: transaction.category,
            amount: Number(transaction.amount),
            date: transaction.date,
            transactions: [transaction]
          }

          categories.push(category);
        }
      }

      // Convert categories to events for Calendar use
      for (const category of categories) {
        let event = {
            start: moment(category.date, 'YYYY-MM-DD').toDate(),
            end: moment(category.date, 'YYYY-MM-DD').toDate(),
            title: `($${category.amount}) ${category.category}`,
            allDay: true,
            category: category.category,
            transactions: category.transactions
        }

        events.push(event);
      }

      return events;
    });
  };

  useEffect(() => {
    getTransactions();
  }, []);

  // Update title of elements with class rbc-event-content
  useLayoutEffect(() => {
    let eventContents = document.getElementsByClassName('rbc-event-content');

    for (const content of eventContents) {
      content.setAttribute('title', 'Category amount and name');
    }
  })

  let expenseCategories = [
    "Donation",
    "Education",
    "Entertainment",
    "Groceries",
    "Housing",
    "Medical",
    "Pets",
    "Reimbursement",
    "Restaurant",
    "Technology",
    "Utilities",
    "Vacation",
    "Work",
    "Other Expense",
  ]

  let incomeCategories = [
    "Gift",
    "Investment",
    "Refund",
    "Salary",
    "Sold Items",
    "Other Income",
  ]

  const eventPropGetter = useCallback(
    (event, start, end, isSelected) => ({
      ...(expenseCategories.some(e => event.title.includes(e)) && {
        style: {
          backgroundColor: '#dc3545',
        }
      }),
      ...(incomeCategories.some(i => event.title.includes(i)) && {
        style: {
          backgroundColor: '#198754',
        }
      }),
      ...(isSelected && {
        style: {
          backgroundColor: '#6c757d',
        },
      }),
    }),
    []
  )

  const onSelectEvent = useCallback((calEvent) => {
    handleShow();
    setModalInfo(calEvent);
  }, [])

  const ModalContent = () => {
    return (
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>{modalInfo.category} Transactions</h3>
            <h4>{moment(modalInfo.start).format("MMMM DD, YYYY")}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="test">
          <Table className="table" striped bordered hover>
            <thead>
              <tr>
                <th>
                  <span>
                    Merchant
                  </span>
                </th>
                <th>
                  <span>
                    Amount
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {
                modalInfo.transactions.map((transaction) => {
                  return (
                    <tr key={transaction.id}>
                        <td>{transaction.merchant}</td>
                        <td>${parseFloat(transaction.amount).toFixed(2)}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>      
      <div className="bodyContent">
        <div className="col-md-6 text-left">
          <h1>Calendar</h1>
          <p><em>Check your transactions per category in calendar view.</em></p>
        </div>
        <Calendar
          localizer={localizer}
          defaultDate={new Date()}
          defaultView="month"
          events={events}
          eventPropGetter={eventPropGetter}
          style={{ height: "90vh" }}
          views={['month']}
          showAllEvents={true}
          onSelectEvent={onSelectEvent}
        />

        {show ? <ModalContent /> : null}
      </div>
      <br/>
      <br/>
    </>
  );
};

export default CalendarPageContent;